var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisconnected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.521)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-45 96 166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 96,42  a 124,124 0 0 1 124,124 l 12,0 a 136,136 0 0 0 -136,-136 z",
    style: {
      fill: "#545454"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 96,66  a 100,100 0 0 1 100,100 l 12,0 a 112,112 0 0 0 -112,-112 z",
    style: {
      fill: "#545454"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 96,90   a 76,76 0 0 1 76,76  l 12,0 a 88,88 0 0 0 -88,-88 z",
    style: {
      fill: "#545454"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 96,114  a 52,52 0 0 1 52,52  l 12,0 a 64,64 0 0 0 -64,-64 z",
    style: {
      fill: "#545454"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 96,166 0,-40 a 40 40  0 0 1 40,40 z",
    style: {
      fill: "#545454"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45,96,96)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D03D32",
      stroke: "none",
      opacity: 0.75
    },
    d: "m 80,10 32,0 0,70 70,0 0,32 -70,0 0,70 -32,0 0,-70 -70,0 0,-32 70,0 z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnected);
export default __webpack_public_path__ + "static/media/Disconnected.6154e2a7c668a9208c08a8b993b3f60a.svg";
export { ForwardRef as ReactComponent };